module.exports = __webpack_public_path__ + "static/media/ow22ll24.10c69d12.png";